import { type RefObject, useEffect } from "react";

export const useClickOutside = (ref: RefObject<HTMLElement | null>, action: () => void, dataAttr?: string) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target instanceof Node ? event.target : null;
      if (!ref.current?.contains(target) && !dataAttr) {
        action();
      }
      if (
        dataAttr &&
        target instanceof HTMLElement &&
        target.dataset[dataAttr] !== dataAttr &&
        !ref.current?.contains(target) &&
        !target.closest(`[data-${dataAttr}=${dataAttr}]`)
      ) {
        action();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, dataAttr]);
};
